import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import classNames from 'classnames';
import { Check, Copy } from '@styled-icons/feather';
import { setTimeout } from 'timers';
import styles from './CopyPasteInput.module.css';

function CopyPasteInput({ value, isFitToContainer }: {value: string, isFitToContainer?: boolean}) {
  const [copied, setcopied] = useState(false);

  const onCopy = () => {
    copy(value);
    setcopied(true);
    setTimeout(() => setcopied(false), 3000);
  };
  return (
    <div className={classNames(styles.container, {
      [styles.containerCopied]: copied,
      [styles.containerFitContent]: isFitToContainer,
    })}
    >
      <input
        type="text"
        value={value}
        onChange={() => { /** do nothing */ }}
        className={classNames(styles.input, {
          'is-ellipsis': isFitToContainer,
        })}
      />
      <Copy size={18} className={styles.copy} onClick={onCopy} />
      {copied && (
      <div className={classNames(styles.copied, 'box-no-border')}>
        <Check size={15} className={styles.check} />
        Copied!
      </div>
      )}
    </div>
  );
}

CopyPasteInput.defaultProps = {
  isFitToContainer: false,
};

export default CopyPasteInput;
